// extracted by mini-css-extract-plugin
export default {"container":"styles_container__-kPOV","tick":"styles_tick__RmeU9","price":"styles_price__aK6kJ"};